import { useContext, useState } from 'react';
import { Modal } from '../BaseModal';
import { AppContext } from '../../../context';

interface Props {
    isOpen: boolean;
    save: (ids: number[]) => void;
}

export const DeleteOperationsCenterModal = ({ isOpen, save }: Props) => {
    const { modalInfoOperationsCenter, setIsDeleteOperationsCenterModal } =
        useContext(AppContext);

    const handlerCloseModal = () => {
        window.localStorage.removeItem('selection-range');
        setIsDeleteOperationsCenterModal(false);
    };

    const handlerSubmit = () => {
        save(modalInfoOperationsCenter.id ?? []);
        setIsDeleteOperationsCenterModal(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle='Eliminar centros de operaciones'
            onClose={handlerCloseModal}
            onSubmit={handlerSubmit}
        >
            <div className='modal-body' style={{ paddingBottom: 0, minHeight: 150 }}>
                <h5>¿Esta seguro que los desea eliminar?</h5>
                <div>
                    <div>
                        <p>
                            Del {modalInfoOperationsCenter.startDate} al{' '}
                            {modalInfoOperationsCenter.endDate}
                        </p>
                        <h6>Empleado/s</h6>
                        <ul className=''>
                            {modalInfoOperationsCenter.employee.map((e) => (
                                <li className=''>{e.text}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
